import React, { useEffect } from 'react';
import { useAuth } from 'providers/AuthenticationProvider';
import BaseUrl from '../constant/baseUrl';

export const Login = () => {
    const { isLogged } = useAuth();

    useEffect(() => {
        // Đã đăng nhập rồi thì KHÔNG được đá ra IdP nữa (tránh login lặp lần 2).
        if (isLogged) {
            return;
        }

        const handleLogin = () => {
            window.location.href = `${process.env.REACT_APP_IDP_SSO_URL}?client_id=${process.env.REACT_APP_IDP_CLIENT_ID}&redirect_uri=${encodeURIComponent(window.location.origin + BaseUrl.XacThuc)}`;
        };

        const timer = setTimeout(handleLogin, 1000); // timeout đợi get token + thông tin login

        // Hủy timer khi Login unmount (đổi route) hoặc khi isLogged đổi -> tránh timer mồ côi
        // bắn ra IdP sau khi user đã vào được app.
        return () => clearTimeout(timer);
    }, [isLogged]);

    return <div className="grid"></div>;
};
